import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000/api' : 'https://apiudayam.ozrit.live/api'),
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('/login');
    const isAiRequest = error.config?.url?.includes('/ai');
    const message = (error.response?.data?.message || '').toLowerCase();
    const isExternalServiceError = message.includes('openai') || message.includes('api key') || message.includes('gateway');

    // Only log out if it is a genuine Admin authentication failure (401),
    // and NEVER for AI checks, OpenAI errors, or external upstream service failures.
    if (error.response?.status === 401 && !isLoginRequest && !isAiRequest && !isExternalServiceError) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
